import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { Link } from 'react-router-dom';

export default function Discover() {
  const [nubbi, setNubbi] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchRandomNubbi = async () => {
    setLoading(true);
    let { data, error } = await supabase.rpc('get_random_character');

    if (error) {
      console.error(error);
    } else {
      setNubbi(data[0]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRandomNubbi();
  }, []);

  if (loading || !nubbi) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white text-3xl font-bold">
        Loading your Nubbi...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white p-8">
      <h1 className="text-center text-5xl font-extrabold mb-12 drop-shadow-lg">🚀 Discover Nubbis</h1>
      
      <div className="flex flex-col md:flex-row justify-center items-center gap-16">
        {/* Imagen del Nubbi */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img 
            src={nubbi.image ?? '/fallback.png'} 
            alt={nubbi.name} 
            className="rounded-3xl shadow-2xl border-4 border-white max-w-[400px] max-h-[400px] object-cover"
          />
        </div>

        {/* Ficha Técnica */}
        <div className="bg-white text-black rounded-3xl p-8 shadow-2xl w-full md:w-[400px]">
          <h2 className="text-3xl font-bold mb-4">{nubbi.name}</h2>
          <p className="text-lg"><b>NUBB-ID:</b> {nubbi.id}</p>
          <p className="text-lg">
            <b>Universe:</b> 
            <Link to={`/universes/${nubbi.universo}`} className="text-blue-600 underline ml-1">
              {nubbi.universo}
            </Link>
          </p>
          <p className="text-lg"><b>Tagline:</b> {nubbi.tagline ?? "—"}</p>
          <p className="text-lg"><b>VS Votes:</b> {nubbi.vs_votes}</p>
          <p className="text-lg">
            <b>Created by:</b> 
            <Link to={`/${nubbi.creador_url}`} className="text-blue-600 underline ml-1">

              {nubbi.creador_url}
            </Link>
          </p>

          <button 
            onClick={fetchRandomNubbi}
            className="mt-8 bg-red-500 text-white font-bold py-3 px-8 rounded-xl text-xl shadow-lg hover:scale-105 transition"
          >
            🔄 Next Nubbi
          </button>
        </div>
      </div>
    </div>
  );
}